/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Link,
  List,
  colors,
  Typography,
  makeStyles,
  SvgIcon
} from '@material-ui/core';
import {
  Home as HomeIcon,
  ShoppingCart as ShoppingCartIcon,
  Lock as LockIcon,
  Layout as LayoutIcon,
  Users as UsersIcon,
  Settings as SettingsIcon,
  ExternalLink as ExternalLinkIcon
} from 'react-feather';
import NavItem from './NavItem';
import getProductType from 'src/components/ProductType';
import { getDifferenceInTime } from 'src/utils/timeZone';

const productType = getProductType();

function navConfig1() {
  const productType = getProductType();
  return [
    {
      subheader: 'Reports',
      items: [
        {
          title: 'Home',
          icon: HomeIcon,
          href: `/${productType.toLowerCase()}/home`
        },
        {
          title: 'Reports',
          icon: LayoutIcon,
          href: `/${productType.toLowerCase()}/reports`
        },
        {
          title: 'Manage users',
          icon: UsersIcon,
          href: `/${productType.toLowerCase()}/users`
        },
        {
          title: 'Manage subscription',
          icon: ShoppingCartIcon,
          href: `/${productType.toLowerCase()}/subscription`
        },
        {
          title: 'API documentation',
          icon: SettingsIcon,
          href: '/apis',
          target: '_blanck'
        },
        {
          title: 'Change password',
          icon: LockIcon,
          href: `/${productType.toLowerCase()}/changePassword`
        }
      ]
    }
  ];
}
function navConfig2() {
  const productType = getProductType();
  return [
    {
      subheader: 'Reports',
      items: [
        {
          title: 'Home',
          icon: HomeIcon,
          href: `/${productType.toLowerCase()}/home`
        },
        {
          title: 'Reports',
          icon: LayoutIcon,
          href: `/${productType.toLowerCase()}/reports`
        },
        {
          title: 'API documentation',
          icon: SettingsIcon,
          href: '/apis',
          target: '_blanck'
        },
        {
          title: 'Change password',
          icon: LockIcon,
          href: `/${productType.toLowerCase()}/changePassword`
        }
      ]
    }
  ];
}

function navConfig3() {
  return [
    {
      subheader: 'Reports',
      items: [
        {
          title: 'Home',
          icon: HomeIcon,
          href: `/${productType.toLowerCase()}/home`
        },
        {
          title: 'Reports',
          icon: LayoutIcon,
          href: `/${productType.toLowerCase()}/reports`
        },
        {
          title: 'Subscribe now',
          icon: ShoppingCartIcon,
          href: `/${productType.toLowerCase()}/newSubscription`
        },
        {
          title: 'API documentation',
          icon: SettingsIcon,
          href: '/apis',
          target: '_blanck'
        },
        {
          title: 'Change password',
          icon: LockIcon,
          href: `/${productType.toLowerCase()}/changePassword`
        }
      ]
    }
  ];
}

function navConfig4() {
  return [
    {
      subheader: 'Reports',
      items: [
        {
          title: 'Home',
          icon: HomeIcon,
          href: `/${productType.toLowerCase()}/home`
        },
        {
          title: 'Reports',
          icon: LayoutIcon,
          href: `/${productType.toLowerCase()}/reports`
        },
        {
          title: 'Manage subscription',
          icon: ShoppingCartIcon,
          href: `/${productType.toLowerCase()}/subscription`
        },
        {
          title: 'API documentation',
          icon: SettingsIcon,
          href: '/apis',
          target: '_blanck'
        },
        {
          title: 'Change password',
          icon: LockIcon,
          href: `/${productType.toLowerCase()}/changePassword`
        }
      ]
    }
  ];
}

function renderNavItems({ items, onMobileClose, ...rest }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, onMobileClose, ...rest }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({
  acc,
  pathname,
  item,
  onMobileClose,
  depth = 0,
  ...rest
}) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={key}
        info={item.info}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={`${item.href}${
          rest?.isUserExpired && item.title === 'Manage subscription'
            ? '/topUpCurrentPlan'
            : ''
        }`}
        icon={item.icon}
        key={key}
        info={item.info}
        title={item.title}
        target={item.target}
        onMobileClose={onMobileClose}
      />
    );
  }

  return acc;
}

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 300,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64,
    backgroundColor: colors.red[600]
  }
}));

function NavBar({ openMobile, onMobileClose }) {
  const classes = useStyles();
  const location = useLocation();
  const { user } = useSelector(state => state.account);
  const { homeDetails } = useSelector(state => state.home);

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  if (!user) {
    return null;
  }

  const content = (
    <PerfectScrollbar options={{ suppressScrollX: true }}>
      <Box
        height="100%"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
      >
        <Box>
          <Box p={2}>
            <Box display="flex" justifyContent="center">
              <RouterLink to={`/${productType.toLowerCase()}/home`}>
                <Avatar
                  alt="User"
                  className={classes.avatar}
                  src={user.avatar}
                />
              </RouterLink>
            </Box>
            <Box mt={2} textAlign="center">
              <Link
                component={RouterLink}
                to={`/${productType.toLowerCase()}/home`}
                variant="h5"
                color="textPrimary"
                underline="none"
              >
                {`${user.user.firstName || ''} ${user.user.lastName || ''}`}
              </Link>
              <Typography variant="body2" color="textSecondary">
                {user.user.email || ''}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {user.user.roles[0].roleName || ''}
              </Typography>
            </Box>
          </Box>
          <Divider style={{ height: '0.8px', backgroundColor: '#f5f5f5' }} />
          <Box p={2}>
            {(user.plan.planName === 'Precisa Pay-Per-Use'
              ? navConfig4()
              : user.user.roles[0].roleName === 'Admin'
              ? navConfig1()
              : user.user.roles[0].roleName === 'User' &&
                user.plan.hasOwnProperty('currentPrice')
              ? navConfig2()
              : navConfig3()
            ).map(config => (
              <List key={config.subheader}>
                {renderNavItems({
                  items: config.items,
                  pathname: location.pathname,
                  onMobileClose: onMobileClose,
                  isUserExpired:
                    (user.plan.planName === 'Precisa Pay-Per-Use' ||
                      user.user.roles[0].roleName === 'Admin') &&
                    getDifferenceInTime(homeDetails?.currentCycleEndDate)
                      .isExpired
                })}
              </List>
            ))}
          </Box>
        </Box>
        <Box p={2}>
          <Box
            p={2}
            mb={1}
            borderRadius="borderRadius"
            bgcolor="background.dark"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box>
              <Typography variant="h6" color="textPrimary">
                Need Help?
              </Typography>
              <Link
                variant="body2"
                color="secondary"
                component={RouterLink}
                target="_blanck"
                to={{
                  pathname: 'https://www.precisa.in/help'
                }}
              >
                Check our documentation
              </Link>
            </Box>
            <SvgIcon color="disabled">
              <ExternalLinkIcon />
            </SvgIcon>
          </Box>
          <Divider style={{ height: '0.8px', backgroundColor: '#f5f5f5' }} />
          <Box pt={2} pb={2} mt={1}>
            <Typography color="textSecondary" variant="body2">
              © Copyright Finezza Technologies Pvt.Ltd
            </Typography>
            <Link
              variant="body2"
              color="secondary"
              component={RouterLink}
              to={`/${productType.toLowerCase()}/contactSupport`}
              target="_blanck"
            >
              Feel free to contact us in case of any confusion
            </Link>
          </Box>
        </Box>
      </Box>
    </PerfectScrollbar>
  );

  return (
    <>
      <Drawer
        anchor="left"
        variant="persistent"
        classes={{ paper: classes.mobileDrawer }}
        onClose={onMobileClose}
        open={openMobile}
      >
        {content}
      </Drawer>
    </>
  );
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;
